import {Club} from 'data/records'
import {resource, collection, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(Club, [
  collection.get('privilegedClubsForUser', ['userId', 'managesMembers', 'managesBilling', 'managesRoutes', 'admin'])
])

const selectors = {
  ...findSelector(Club),
  byUserId: (state, userId) => state.apiv3.club.id.filter(c => c.userId === userId).first()
}

const reducers = {}

const initialState = {}

export {
  api as clubApi,
  actions as clubActions,
  selectors as clubSelectors,
  reducers as clubReducers,
  initialState as clubInitialState
}
